import styled from '@emotion/styled';
import classNames from 'classnames';
import React, { ReactNode } from 'react';
import { border_radius_styles_with_size, semantic_colors } from '../../foundation';
import { buildCSSWithLength } from '../../styles';
import { DataTableMode, Scroll } from './types';
import { SCROLL_MAX_HEIGHT } from './constants';

interface TableContainerProps {
  children: ReactNode;
  scroll?: Scroll;
  mode?: DataTableMode;
  className?: string;
}

export const TableContainer = React.forwardRef<HTMLDivElement, TableContainerProps>(
  ({ children, scroll, mode = 'container', className }: TableContainerProps, ref) => {
    const containerScroll = mode === 'page' ? scroll : { y: SCROLL_MAX_HEIGHT, ...scroll };

    return (
      <ContainerWrapper className={classNames('pds-table-container-wrapper', className)} $mode={mode}>
        <Container
          ref={ref}
          className={classNames('pds-table-container', className)}
          scroll={containerScroll}
          $mode={mode}
        >
          {children}
        </Container>
      </ContainerWrapper>
    );
  },
);

const ContainerWrapper = styled.div<{ $mode: DataTableMode }>`
  overflow: ${({ $mode }) => ($mode === 'page' ? 'visible' : 'hidden')};
  border: 1px solid ${semantic_colors.border.primary};
  border-radius: ${border_radius_styles_with_size.small}px;
`;

const Container = styled.div<{ scroll?: Scroll; $mode: DataTableMode }>`
  ${({ $mode }) =>
    $mode === 'page'
      ? `
        overflow-x: auto;
        overflow-y: visible;
      `
      : 'overflow: auto;'}
  border-radius: ${border_radius_styles_with_size.small}px;
  ${({ $mode, scroll }) =>
    $mode === 'container' &&
    scroll?.y &&
    `
      ${buildCSSWithLength('max-height', scroll.y ?? 'auto')};
    `}
`;
